import { useCallback as e, useEffect as t, useState as n } from "react";
//#region src/components/DatePicker/hooks/useDraftRange.ts
function r(r) {
	let [i, a] = n(r?.start ?? null), [o, s] = n(r?.end ?? null);
	return t(() => {
		a(r?.start ?? null), s(r?.end ?? null);
	}, [r?.start, r?.end]), {
		draftStart: i,
		draftEnd: o,
		setDraftStart: a,
		setDraftEnd: s,
		reset: e(() => {
			a(r?.start ?? null), s(r?.end ?? null);
		}, [r?.start, r?.end])
	};
}
//#endregion
export { r as useDraftRange };
